export default {
  darkMode: {
    toggle: 'Mørk tilstand',
  },
  common: {
    languageSwitcher: {
      switchToEnglish: 'Switch to English',
      switchToDanish: 'Skift til dansk',
      en: 'EN',
      da: 'DA',
    },
    fiveStarRating: '5 ★',
    outOfFiveStars: 'ud af 5',
    outOf5: '/ 5',
    trustpilotRating: '4.6 ★',
    closePopup: 'Luk',
    close: 'Luk',
    readMore: 'Læs mere',
    seeAll: 'Se alle',
    getStarted: 'Kom i gang',
    orderNow: 'Bestil nu',
    learnMore: 'Læs mere',
    contact: 'Kontakt',
    faq: 'FAQ',
    blog: 'Blog',
    back: 'Tilbage',
    cancel: 'Annuller',
    moreInfo: 'Mere information',
    lessInfo: 'Mindre information',
    seeAllQuestions: 'Se alle spørgsmål →',
    freeForever: 'Gratis for altid',
    popular: 'Populær',
    superSaver: 'Super saver',
    supportNature: 'Støt naturen',
    completePackage: 'Komplet pakke',
    noBinding: 'Ingen binding',
    oneMonthNotice: '1 måneds opsigelsesvarsel',
    cancelAnytime: 'Opsig når som helst',
    optional: 'Valgfri',
    chargerOnly: 'Kun ladeboks',
    note: 'Bemærk',
  },

  // Works with all chargers (Virker enkel med alle ladebokse)
  worksWithAllChargers: {
    heroTitle: 'Virker enkel med alle ladebokse?',
    heroSubtitle: 'Ja – Saving Mode fungerer med de fleste populære ladebokse på markedet',
    intro1: '<strong>Ja</strong>, vores Saving Mode-løsning fungerer med de fleste populære ladebokse på markedet, herunder Zaptec og NexBlue.',
    intro2: 'Saving Mode virker via ladeboksens cloud-forbindelse, så du automatisk oplader på de billigste tidspunkter.',
    compatibleChargersTitle: 'Kompatible ladebokse',
    haveOtherCharger: 'Har du en anden ladeboks? <strong>Kontakt os</strong>, så tjekker vi om den er kompatibel.',
    howSmartChargeWorks: 'Sådan virker Saving Mode',
    controlViaApp: 'Styr via app',
    controlViaAppText: 'Sæt din ønskede afgangstid og batteriniveau i enkel appen.',
    autoOptimization: 'Automatisk optimering',
    autoOptimizationText: 'Saving Mode finder automatisk de billigste timer og planlægger din opladning.',
    fullControl: 'Fuld kontrol',
    fullControlText: 'Du kan altid starte opladning manuelt eller overstyre automatikken.',
    noChargerQ: 'Har du ikke en ladeboks?',
    noChargerText: 'Mange elbiler har indbygget smart opladning. Du kan bruge din bils app til at sætte afgangstid.',
    evsWithBuiltIn: 'Elbiler med indbygget smart opladning:',
    teslaModels: 'Tesla Model S, 3, X, Y',
    vwId: 'VW ID.3, ID.4, ID.5',
    audiEtron: 'Audi e-tron GT, Q4 e-tron',
    bmwModels: 'BMW iX, i4, i7',
    mercedesEq: 'Mercedes EQA, EQB, EQC, EQE, EQS',
    andMore: 'Og mange flere...',
    setupProcess: 'Sådan kommer du i gang',
    step1: 'Download enkel appen',
    step1Text: 'Tilgængelig til iOS og Android',
    step2: 'Tilslut din ladeboks',
    step2Text: 'Følg guiden i appen for at forbinde',
    step3: 'Sæt dine præferencer',
    step3Text: 'Vælg afgangstid og ønsket batteriniveau',
    benefitsTitle: 'Fordele ved Saving Mode',
    saveMoney: 'Spar penge',
    saveMoneyText: 'Oplad automatisk når strømmen er billigst.',
    alwaysReady: 'Altid klar',
    alwaysReadyText: 'Din bil er altid opladet når du skal bruge den.',
    easyControl: 'Nem kontrol',
    easyControlText: 'Alt styres fra enkel appen.',
    faqTitle: 'Ofte stillede spørgsmål',
    faq1Q: 'Virker Saving Mode med min ladeboks?',
    faq1A: 'Saving Mode virker med Zaptec Go, Zaptec Go 2, NexBlue Edge 2, Easee og flere andre ladebokse. Kontakt os for at tjekke din specifikke model.',
    faq2Q: 'Kan jeg bruge Saving Mode uden ladeboks?',
    faq2A: 'Ja, mange elbiler har indbygget smart opladning som kan bruges til at planlægge opladning.',
    faq3Q: 'Koster Saving Mode ekstra?',
    faq3A: 'Nej, Saving Mode er inkluderet i alle vores elaftaler uden ekstra omkostninger.',
    faq4Q: 'Hvad hvis jeg skal køre før den planlagte tid?',
    faq4A: 'Du kan altid starte opladning manuelt via appen eller direkte på ladeboksen.',
    readyToOptimize: 'Klar til at optimere din opladning?',
    readyToOptimizeText: 'Skift til enkel og få Saving Mode inkluderet',
    seeElPlans: 'Se elaftaler',
    seeChargers: 'Se ladebokse',
  },

  // FAQ Page
  faqPage: {
    faqTitle: 'Ofte stillede spørgsmål',
  },

  // Contact Flow
  flow: {
    error: {
      submitFailed: 'Der opstod en fejl. Prøv venligst igen.',
      requiredFields: 'Udfyld venligst navn, e-mail og besked.',
      phoneRequiredUrgent: 'Ved akutte henvendelser bedes du angive et telefonnummer, så vi kan ringe dig op.',
    },
    gate: {
      title: 'Er du kunde hos enkel energi?',
      desc: 'Vælg det der passer bedst til dig',
      yes: 'Ja, jeg er kunde',
      no: 'Nej, endnu ikke',
    },
    customerValidate: {
      title: 'Indtast dit kundenummer',
      desc: 'Du finder dit kundenummer i din velkomst-mail eller på din elregning',
      customerNumber: 'Kundenummer',
      customerNumberPlaceholder: 'K1234567',
    },
    customerPhoneFallback: {
      title: 'Kan du ikke finde dit kundenummer?',
      desc: 'Indtast dit telefonnummer, så finder vi dig',
      phone: 'Telefonnummer',
      phonePlaceholder: '+45 12 34 56 78',
    },
    customerIntent: {
      title: 'Hvad kan vi hjælpe dig med?',
      desc: 'Vælg det emne der passer bedst',
      urgentEv: 'Min elbil lader ikke',
      powerOutage: 'Problem med strøm',
      appIssue: 'Hjælp med app',
      billing: 'Regning & betaling',
      planChange: 'Ændre aftale',
      addAddress: 'Tilføj adresse',
      buyHardware: 'Køb ladeboks',
      solar: 'Solceller',
      other: 'Andet',
    },
    urgentEv: {
      title: 'Elbil lader ikke',
      desc: 'Lad os hjælpe dig med at finde problemet',
      chargerModel: 'Hvilken ladeboks har du?',
      otherCharger: 'Anden ladeboks',
      hasPower: 'Har ladeboksen strøm?',
      yes: 'Ja',
      no: 'Nej',
      unsure: 'Ved ikke',
      zaptec: {
        checkApp: 'Tjek Zaptec appen – er ladeboksen online?',
        checkCable: 'Tjek at kablet er ordentligt tilsluttet',
        restartCharger: 'Genstart ladeboksen via appen',
        checkLED: 'Tjek LED-lyset på ladeboksen',
        checkBreaker: 'Tjek sikringen i eltavlen',
        checkRCD: 'Tjek HFI/HPFI-relæet',
        powerCycle: 'Sluk og tænd for sikringen',
      },
      zaptecGo2: {
        checkApp: 'Tjek Zaptec appen – er ladeboksen online?',
        checkCable: 'Tjek at kablet er ordentligt tilsluttet',
        restartCharger: 'Genstart ladeboksen via appen',
        checkLED: 'Tjek displayet på ladeboksen',
        checkBreaker: 'Tjek sikringen i eltavlen',
        checkRCD: 'Tjek HFI/HPFI-relæet',
        powerCycle: 'Sluk og tænd for sikringen',
      },
      nexblue: {
        checkApp: 'Tjek NexBlue appen – er ladeboksen online?',
        checkCable: 'Tjek at kablet er ordentligt tilsluttet',
        checkLED: 'Tjek LED-lyset på ladeboksen',
        restartCharger: 'Genstart ladeboksen via appen',
        checkBreaker: 'Tjek sikringen i eltavlen',
        checkRCD: 'Tjek HFI/HPFI-relæet',
        powerCycle: 'Sluk og tænd for sikringen',
      },
      general: {
        checkCarLocked: 'Tjek at bilen er låst op for opladning',
        checkCarChargingLimit: 'Tjek bilens ladegrænse i bilens indstillinger',
        tryDifferentSocket: 'Prøv at tilslutte kablet igen',
        checkWeather: 'Tjek om ladestikket er vådt eller snavset',
      },
    },
    urgentEvTips: {
      title: 'Prøv disse ting først',
      desc: 'Disse løsninger hjælper ofte',
    },
    power: {
      title: 'Problem med strøm',
      desc: 'Fortæl os mere om problemet',
      issueType: 'Hvad er problemet?',
      noPower: 'Ingen strøm i hele huset',
      partial: 'Delvist strømnedbrud',
      billingOnly: 'Kun spørgsmål til regning',
      instant1: 'Tjek sikringerne i din eltavle',
      instant2: 'Kontakt dit netselskab ved strømnedbrud',
      instant3: 'Enkel leverer el – netselskabet leverer strømmen fysisk',
    },
    powerTips: {
      title: 'Vigtig info om strømnedbrud',
      desc: 'Ved strømnedbrud skal du kontakte dit netselskab',
    },
    app: {
      title: 'Hjælp med app',
      desc: 'Hvad har du brug for hjælp til?',
      issueType: 'Vælg problem',
      cantLogin: 'Kan ikke logge ind',
      chargerNotConnect: 'Ladeboks forbinder ikke',
      smartChargeNotWork: 'Saving Mode virker ikke',
      cantSeeData: 'Kan ikke se data',
      other: 'Andet',
      instant1: 'Tjek at du har den nyeste version af appen',
      instant2: 'Prøv at logge ud og ind igen',
      instant3: 'Tjek din internetforbindelse',
      instant4: 'Genstart appen',
    },
    billing: {
      title: 'Regning & betaling',
      desc: 'Hvad har du brug for hjælp til?',
      issueType: 'Vælg emne',
      questionAmount: 'Spørgsmål til beløb',
      paymentFailed: 'Betalingen mislykkedes',
      refund: 'Refusion',
      other: 'Andet',
      instant1: 'Du kan se alle dine fakturaer i kundeportalen',
      instant2: 'Aconto-beløb reguleres ved årsopgørelsen',
      instant3: 'Hvis betalingen mislykkes, skal du tjekke dit betalingskort',
      instantPortal: 'Gå til kundeportalen for at se dine fakturaer',
    },
    planChange: {
      title: 'Ændre aftale',
      desc: 'Kontakt os for at ændre din aftale',
    },
    address: {
      title: 'Tilføj adresse',
      desc: 'Vil du tilføje en ny adresse?',
      addressType: 'Hvilken type adresse?',
      summerHouse: 'Sommerhus',
      newPrimary: 'Ny primær adresse (flytning)',
      other: 'Andet',
    },
    addressSummer: {
      title: 'Sommerhus',
      desc: 'Du kan nemt tilføje el til dit sommerhus',
      instant1: 'Gå til vores tilmeldingsside',
      instant2: 'Vælg din ønskede elaftale',
      instant3: 'Indtast adressen på dit sommerhus',
    },
    addressPrimary: {
      title: 'Flytning',
      desc: 'Vi hjælper dig med at flytte din aftale',
      instant1: 'Kontakt os med din nye adresse',
      instant2: 'Vi opretter din aftale på den nye adresse',
    },
    hardware: {
      title: 'Køb ladeboks',
      desc: 'Hvilken ladeboks er du interesseret i?',
      hardwareType: 'Vælg ladeboks',
      needsInstall: 'Har du brug for installation?',
      yes: 'Ja',
      no: 'Nej',
    },
    hardwareRedirect: {
      title: 'Se ladeboks',
      desc: 'Vi sender dig videre til den valgte ladeboks',
    },
    customerSolar: {
      title: 'Solceller',
      desc: 'Fortæl os om dine solceller',
      hasPanels: 'Har du solceller?',
      yes: 'Ja, jeg har solceller',
      planning: 'Planlægger at få solceller',
      no: 'Nej',
    },
    solarYes: {
      title: 'Solcelleaftale',
      desc: 'Få vores gratis solcelleaftale',
      instant1: 'Enkel tilbyder gratis produktionsaftale',
      instant2: 'Ingen leverandørgebyrer',
      instant3: 'Tilføj solcelleaftale når du tilmelder el',
    },
    solarPlanning: {
      title: 'Planlægger solceller',
      desc: 'Godt at vide når du får solceller',
      instant1: 'Enkel tilbyder gratis produktionsaftale',
      instant2: 'Kontakt os når dine solceller er installeret',
    },
    solarNo: {
      title: 'Ingen solceller',
      desc: 'Du kan altid tilføje solcelleaftale senere',
      instant1: 'Kontakt os når du er klar',
    },
    leadTopic: {
      title: 'Hvad vil du gerne vide mere om?',
      desc: 'Vælg et emne',
      electricity: 'Elaftale',
      charger: 'Ladeboks',
      solar: 'Solceller',
      app: 'Saving Mode app',
      other: 'Andet',
    },
    leadElectricityInfo: {
      title: 'Elaftale fra enkel',
      desc: 'Få billig strøm uden tillæg',
      bullet1: 'Spotpris uden tillæg',
      bullet2: 'Abonnement fra kun 18 kr./md',
      bullet3: 'Ingen binding',
      bullet4: 'Saving Mode app inkluderet',
    },
    leadElectricityDetails: {
      title: 'Fortæl os lidt mere',
      desc: 'Så vi kan give dig de bedste anbefalinger',
      hasEv: 'Har du en elbil?',
      planning: 'Planlægger at købe',
      contextBullet: 'Med elbil kan du spare op til 30% med Saving Mode',
    },
    leadElectricityWithEv: {
      title: 'Perfekt til elbilsejere',
      desc: 'Spar op til 30% på din opladning',
      bullet1: 'Saving Mode optimerer automatisk din opladning',
      bullet2: 'Se vores ladebokse for komplet løsning',
    },
    leadChargerInfo: {
      title: 'Ladebokse fra enkel',
      desc: 'Kvalitets-ladebokse til skarpe priser',
      bullet1: 'Zaptec Go fra 4.499 kr.',
      bullet2: 'Zaptec Go 2 fra 5.999 kr.',
      bullet3: 'NexBlue Edge 2 fra 3.999 kr.',
      bullet4: 'Valgfri installation',
    },
    leadSolarInfo: {
      title: 'Solcelleaftale fra enkel',
      desc: 'Gratis produktionsaftale',
      bullet1: '0 kr. i leverandørgebyr',
      bullet2: 'Automatisk afregning',
      bullet3: 'Den eneste gratis i Danmark',
    },
    leadAppInfo: {
      title: 'Saving Mode app',
      desc: 'Inkluderet for alle kunder',
      bullet1: 'Automatisk prisbaseret opladning',
      bullet2: 'Vælg afgangstid og ønsket batteriniveau',
      bullet3: 'Se dit forbrug og historik',
      bullet4: 'Virker med Zaptec og NexBlue',
    },
    finalForm: {
      title: 'Send os en besked',
      desc: 'Vi vender tilbage hurtigst muligt',
    },
    success: {
      customerTitle: 'Vi har modtaget din henvendelse!',
      customerMessage: 'Vores kundeservice kontakter dig hurtigst muligt.',
      leadTitle: 'Tak for din interesse!',
      leadMessage: 'Vi kontakter dig inden for 24 timer.',
      caseId: 'Sagsnummer',
      backToHome: 'Tilbage til forsiden',
      visitFaq: 'Se FAQ',
      newRequest: 'Send en ny henvendelse',
      thankDuTitle: 'Tak for din henvendelse!',
      thankDuMessage: 'Vi har modtaget din besked og vender tilbage til dig hurtigst muligt.',
      urgentTitle: 'Er det ekstra akut?',
      urgentMessage: 'Hvis dit ærinde ikke kan vente, kan du ringe til os - men vi anbefaler at følge din sag via mail først.',
      showPhone: 'Vis telefonnummer',
      phoneLabel: 'Telefon',
      openingHoursLabel: 'Åbningstider:',
      weekdaysHours: 'Mandag–fredag: 09:00–13:00',
      weekendHours: 'Weekend: Lukket',
      haveInfoReady: 'Hav gerne dit kundenummer og relevante oplysninger klar.',
    },
    common: {
      yes: 'Ja',
      no: 'Nej',
      back: 'Tilbage',
      next: 'Næste',
      submit: 'Send',
      stillNeedHelp: 'Har du stadig brug for hjælp?',
      contactUs: 'Kontakt os',
      didThisHelp: 'Løste dette dit problem?',
      solved: 'Ja, problemet er løst',
      needMoreHelp: 'Nej, jeg har brug for mere hjælp',
      selectPlaceholder: 'Vælg...',
    },
    buttons: {
      back: 'Tilbage',
      continue: 'Fortsæt',
      next: 'Næste',
    },
    validation: {
      invalidCustomerNumber: 'Ugyldigt kundenummer',
      customerNumberFormat: 'Kundenummeret skal være i formatet K + 7 cifre (f.eks. K1234567)',
      tryAgain: 'Prøv igen',
      usePhoneInstead: 'Brug telefonnummer i stedet',
    },
    contextPanel: {
      helpTitle: 'Hjælp',
      helpText: 'Vi er her for at hjælpe dig. Vælg en mulighed for at komme videre.',
      leadHelpText: 'Velkommen! Hvad vil du gerne vide mere om?',
      quickLinks: 'Hurtige links',
      browseFaq: 'Gennemse FAQ',
      electricityPlans: 'Se elaftaler',
      chargerPackages: 'Se ladebokse',
      solarAgreement: 'Solcelleaftale',
      quickTips: 'Hurtige tips',
    },
    troubleshooting: {
      tryTheseFirst: 'Prøv disse ting først',
      followSteps: 'Følg disse trin for at løse problemet:',
      quickTips: 'Hurtige tips',
    },
    helpPage: {
      moreInfo: 'Mere information',
      didntHelp: 'Det hjalp ikke – kontakt os',
    },
    infoPage: {
      nextSteps: 'Næste skridt',
      stillNeedHelp: 'Har du stadig brug for hjælp?',
    },
    hardwareRedirect: {
      ready: 'Klar til at bestille',
      continue: 'Fortsæt til ladeboks-siden',
      viewCharger: 'Se ladeboks',
    },
    links: {
      faq_app_help: 'Hjælp med appen',
      download_app: 'Download appen',
      faq_power_outage: 'Om strømnedbrud',
      external_grid_company: 'Find dit netselskab',
      page_electricity_plans: 'Se elaftaler',
      page_chargers: 'Se ladebokse',
      customer_portal: 'Åbn kundeportal',
      faq_charger_troubleshoot: 'Fejlfinding af ladeboks',
      faq_smart_charge_quick: 'Hurtig guide til Saving Mode',
      faq_billing: 'Hjælp med regning',
      faq_understand_bill: 'Forstå din regning',
      faq_app: 'Hjælp med appen',
      faq_which_charger: 'Hvilken ladeboks skal jeg vælge?',
      page_solar: 'Se solcelleaftale',
      page_smart_charge: 'Læs om Saving Mode',
      page_comparison: 'Sammenlign elselskaber',
    },
    instantAnswers: {
      title: 'Hurtige svar',
      learnMore: 'Læs mere',
      continueFlow: 'Fortsæt',
    },
    planChange: {
      phoneOnlyTitle: 'Ring til os',
      phoneOnlyDesc: 'Ændringer af din aftale håndteres bedst over telefonen, så vi kan sikre den bedste løsning for dig.',
      openingHours: 'Man-Fre: 9:00-13:00 (telefon)',
    },
    free: 'gratis',
    optional: 'Valgfri',
    note: 'Bemærk',
    priceFrom: 'Pris fra',
    showLess: 'Vis mindre',
    readFullReviews: 'Læs hele anmeldelserne',
    review1Name: 'Michael Rasmussen',
    review2Name: 'Mikkel Andreasen',
    review3Name: 'Thomas Hansen',
    chargerOnly: 'Kun ladeboks',
    sendEmail: 'Send e-mail',
    callUs: 'Ring til os',
    home: 'Forside',
    enkelEnergiCompany: 'enkel energi',
    enkelEnergiPrice: '28 kr.',
    ewiiCompany: 'EWII',
    ewiiPrice: '54 kr.',
    okCompany: 'OK',
    okPrice: '105 kr.',
    norlysCompany: 'Norlys',
    norlysPrice: '150 kr.',
    andelCompany: 'Andel',
    andelPrice: '164 kr.',
    stromligningScoreTitle: 'Strømligning Score',
    stromligningRating: 'Enkel Energi er bedømt til {score} ud af 5 stjerner.',
    stromligningCertifiedTitle: 'Certificeret af Strømligning',
    stromligningCertifiedText: 'Enkel Energi har forpligtet sig til at følge Strømlignings kodeks for god skik, overholde dansk lovgivning og deltage i uvarslede kontroller.',
    scoreOutOf5: '{score} ud af 5',
    ratedStars: 'er bedømt til {score} ud af 5 stjerner',
  },
  nav: {
    elAftaler: 'El-Aftaler',
    ladelosninger: 'Ladeløsninger',
    sammenlignPriser: 'Sammenlign Priser',
    support: 'Support',
    signUp: 'Tilmeld dig',
    login: 'Log ind',
    getElAftale: 'Få en elaftale',
    customerPortal: 'Kundeportal',
    elAftalerDesc: 'Se alle vores elaftaler',
    chargingPlusEl: 'Ladning + Strøm',
    chargingPlusElDesc: 'Se vores ladeboks + strøm aftaler',
    solarAgreement: 'Solcelleaftale',
    solarAgreementDesc: 'Produktionsaftale uden leverandørgebyr',
    allChargingSolutions: 'Alle ladeløsninger',
    allChargingSolutionsDesc: 'Se vores komplette udvalg',
    popularCharger: 'Populær ladeboks',
    newestModel: 'Nyeste model',
    affordableSolution: 'Prisvenlig løsning',
    smartChargeDesc: 'Optimer din opladning automatisk',
    comparison: 'Sammenligning',
    comparisonDesc: 'Sammenlign os med andre',
    electricityPrices: 'Strømpriser',
    electricityPricesDesc: 'Forstå og se priser',
    electricityFromEnkel: 'Strøm fra enkel',
    electricityFromEnkelDesc: 'Kan alle få strøm fra os?',
    help: 'Hjælp',
    customerPortalSupport: 'Kundeportal & support',
    customerPortalSupportDesc: 'FAQ, kontakt og kundeportal samlet ét sted',
    faqDesc: 'Ofte stillede spørgsmål',
    contactUs: 'Kontakt os',
    contactUsDesc: 'Vi er her for at hjælpe',
    resources: 'Ressourcer',
    blogDesc: 'Læs vores artikler',
  },
  footer: {
    companyName: 'enkel energi ApS',
    addressLine1: 'Bryghuspladsen 8',
    addressLine2: '1473 København K',
    cvr: 'CVR: 44925702',
    openingHours: 'Åbningstider',
    weekdaysPhone: 'Telefon: Mandag–fredag 09:00–13:00',
    weekdaysEmail: 'Email/henvendelser: Man-Fre 9:00-17:00',
    weekendClosed: 'Weekend: Lukket',
    navigation: 'Navigation',
    legal: 'Juridisk',
    deliveryTerms: 'Leveringsbetingelser',
    privacyPolicy: 'Privatlivspolitik',
    cookiePolicy: 'Cookiepolitik',
    fees: 'Gebyrer',
    followUs: 'Følg os',
    tagline: 'Smart for økonomien, enkelt i hverdagen',
    copyright: '© {year} enkel energi ApS. Alle rettigheder forbeholdes.',
    aboutUs: 'Om os',
  },
  breadcrumbs: {
    home: 'Forside',
    elaftale: 'Elaftale',
    opladere: 'Opladere',
    solcelleaftale: 'Solcelleaftale',
    smartCharge: 'Saving Mode',
    faq: 'FAQ',
    blog: 'Blog',
    contact: 'Kontakt',
    comparePrices: 'Sammenlign Priser',
    prices: 'Priser',
    canAll: 'Kan alle få strøm fra enkel?',
    zaptecGo: 'Zaptec Go',
    zaptecGo2: 'Zaptec Go 2',
    nexblueEdge2: 'NexBlue Edge 2',
    gebyrer: 'Gebyrer',
    privatlivspolitik: 'Privatlivspolitik',
    leveringsbetingelser: 'Leveringsbetingelser',
    privatlivspolitik: 'Privatlivspolitik',
    cookiepolitik: 'Cookiepolitik',
  },
  chargerBrands: {
    zaptecGo: 'Zaptec Go',
    zaptecGo2: 'Zaptec Go 2',
    zaptecGoBoth: 'Zaptec Go & Go 2',
    nexblueEdge2: 'NexBlue Edge 2',
    easee: 'Easee',
    downloadGooglePlay: 'Hent på Google Play',
    downloadAppStore: 'Hent på App Store',
  },
  seo: {
    defaultDesc: 'Billig strøm til spotpris uden tillæg. Saving Mode til elbil inkluderet.',
    zaptecGoDesc: 'Zaptec Go ladeboks med Saving Mode. 22 kW, Wi-Fi + 4G, load balancing. Fra 4.499 kr. inkl. elaftale.',
    zaptecGo2Desc: 'Zaptec Go 2 ladeboks – nyeste model. V2G ready, 22 kW, Wi-Fi + 4G. Fra 5.999 kr. inkl. elaftale.',
    nexblueDesc: 'NexBlue Edge 2 – prisvenlig ladeboks. 22 kW, Wi-Fi, V2X ready. Fra 3.999 kr. inkl. elaftale.',
    solarTitle: 'Solcelleaftale uden leverandørgebyr | enkel energi',
    solarDesc: 'Få produktionsaftale til dine solceller uden leverandørgebyr. Ingen månedlige gebyrer.',
  },
  forsideHardcoded: {
    result: 'Resultat:',
    danmarksBilligste: 'Skarp pris',
    januar2026: 'Januar 2026',
    testOf14: 'Test af 14 udbydere',
    cheapestSolution: 'billigste ladeløsning',
    review1Full: 'Super kundeservice og regningen stemmer. Det burde være en standard men det er det desværre ikke, mange selskaber snyder med skjulte tillæg til spotprisen. Men ikke Enkel Energi, der er ikke en øre i forskel på min regning og den reelle spotpris. Havde i går en længere samtale med deres kundeservice, vælgst kompetent kundeservice der vidste hvad der blev talt om. Vi har været kunde med vores sommerhus i nogle måneder og skifter nu også til Enkel Energi på hjemmeadressen. stor anbefaling herfra',
    review1Short: 'Super kundeservice og regningen stemmer. Det burde være en standard men det er det desværre ikke, mange selskaber snyder med skjulte tillæg til spotprisen. Men ikke Enkel Energi...',
    review2Full: 'Gode priser og super hjælpsom support. Da jeg ikke var blevet inviteret til deres app i første omgang, skrev jeg i forbindelse med at jeg modtog en mail om opdatering af app. De var lynhurtige til at kontakte mig og vi fandt også en fejl i signup processen i den opdaterede app. Den blev hurtigt rettet og jeg blev holdt informeret løbende. Meget positiv oplevelse.',
    review2Short: 'Gode priser og super hjælpsom support. Da jeg ikke var blevet inviteret til deres app i første omgang, skrev jeg i forbindelse med at jeg modtog en mail...',
    review3Full: 'Har nu et par gange haft kontakt til enkel energi. Begge gange Mathias, som virkelig har ydet en god og professionel hjælp. Meget venlig og kompetent. Billige og gennemskuelige priser, har nu skiftet til dem, både hjem og sommerhus, incl serviceaftale.',
    review3Short: 'Har nu et par gange haft kontakt til enkel energi. Begge gange Mathias, som virkelig har ydet en god og professionel hjælp. Meget venlig og kompetent...',
    latestRecognition: 'Seneste anerkendelser',
  },
  opladereHardcoded: {
    result: 'Resultat:',
    danmarksBilligste: 'Skarp pris',
    januar2026: 'Januar 2026',
    testOf14: 'Test af 14 udbydere',
    cheapestSolution: 'billigste ladeløsning',
  },
  miniCarousel: {
    enterPostalConsumption: 'Indtast postnummer og forbrug for personlig pris',
    postalPlaceholder: 'Post',
    standardRange: 'Standard husholdning: 4.000-8.000 kWh/år',
    gridCompany: 'Netselskab:',
    elAftaler: 'Elaftaler',
    ladebokse: 'Ladebokse',
    lowestPrice: 'Laveste pris',
    popular: 'Populær',
    supportNature: 'Støt naturen',
    quarterlyBilling: 'Kvartalsafregning',
    monthlyBilling: 'Månedsafregning',
    typicalTotal: 'Typisk totalpris',
    inclSubscription: 'inkl. {price} kr./md. abonnement',
    spotPriceNoMarkup: 'Spotpris uden tillæg',
    seeDetails: 'Se detaljer →',
    reliable: 'Pålidelig',
    mostPopular: 'Mest populær',
    premium: 'Premium',
    bestPriceDk: 'Skarp pris',
    v2gReady: 'V2G-ready',
    chargerLabel: 'Ladeboks',
    from: 'fra',
    moreInstallOptions: 'flere installationsmuligheder',
    elAftaleIncluded: 'Elaftale inkluderet',
  },
  barChart: {
    summerhouse: 'Sommerhus',
    apartment: 'Lejlighed',
    house: 'Hus',
    withEv: '+ Elbil',
    enkelEnergi: 'enkel energi',
    otherCompanies: 'Andre selskaber',
    others: 'Andre',
    yearlyHandlerCost: 'Årlig handlerpris (abonnement + tillæg til spotpris)',
    youSave: 'Du sparer {amount} kr./år',
    withEnkelEnergi: 'med enkel energi',
    aboutComparison: 'Om sammenligningen:',
    comparisonDisclaimer: 'Sammenligning baseret på årlig handlerpris (abonnement + tillæg til spotpris) fra Strømligning.dk. Priser kan variere efter forbrug og zone.',
    dataFrom3rdParty: 'Kilde: strømligning.dk',
  },
  dynamicPricing: {
    priceUpdated: 'Pris opdateret',
    priceExplanation: 'Prisforklaring',
    priceExplanationDesc: 'Sådan er din elpris sammensat',
    typicalTotalPrice: 'Typisk totalpris',
    consumptionBasis: 'Beregningsgrundlag: {consumption} kWh/år',
    calculationBasis: 'Beregningsgrundlag: {consumption} kWh/år',
    priceZone: 'Prisområde: {zone}',
    estimatedPrices: 'Estimerede priser – Live-priser hentes',
    allPricesInclVat: 'Alle priser er inkl. moms (25%)',
    enkelElhandler: 'enkel (elhandler)',
    enkelExplanation: 'Dette er hvad du betaler til Enkel Energi. Vi fastsætter eller påvirker ikke net-tariffer eller afgifter.',
    spotPrice: 'Spotpris',
    spotSurcharge: 'Spotpris tillæg',
    subscription: 'Abonnement',
    consumptionSurcharge: 'Forbrugsafregning tillæg',
    yourGridCompany: 'Dit Netselskab ({name})',
    gridCompanyExplanation: 'Dit netselskab vælges efter din bopæl. Disse priser er regulerede og uden for Enkel Energis kontrol.',
    distribution: 'Distribution',
    total: 'Samlet',
    energinet: 'Energinet',
    tariffs: 'Tariffer',
    calculatedElTax: 'Beregnet el-afgift',
    elTax: 'El-afgift',
    vatExplanation: 'Spotpris {inclVat} øre/kWh inkl. moms ({vatOnly} øre moms af {exVat} øre)',
    calculatedPrice: 'Beregnede priser – kunne ikke hente live-priser',
    updatedPrice: 'Priser opdateret',
    enterPostalConsumption: 'Indtast postnummer og forbrug for præcise priser',
    postalPlaceholder: '2100',
  },
  // Marketing pages
  marketing: {
    chargers: 'Ladebokse',
    heroSubtitle: 'Kvalitetsladebokse med valgfri elaftale og installation',
    heroNote: 'Alle ladebokse er kompatible med enkel Saving Mode',
    seeChargers: 'Se ladebokse',
    saveUp30: 'Spar op til 30%',
    withSmartEl: 'med Smart El',
    freeSolar: 'Gratis solcelleaftale',
    onlyInDenmark: '0 kr. leverandørgebyr',
    enkelApp: 'enkel app',
    aiCharging: 'AI-styret opladning',
    flexibleBilling: 'Fleksibel afregning',
    acontoOrConsumption: 'Aconto eller forbrugsafregning',
    chooseCharger: 'Vælg din ladeboks',
    allCompatible: 'Alle ladebokse er kompatible med enkel Saving Mode',
    seeCharger: 'Vælg ladeboks',
    chargerOnly: 'Kun ladeboks',
    getMoreTitle: 'Få mere med enkel',
    getMoreSubtitle: 'Tilføj en elaftale og få adgang til alle fordele',
    spotNoMarkup: 'Spotpris uden tillæg',
    save30Charging: 'Spar op til 30% på opladning',
    freeSmartCharge: 'Gratis Saving Mode inkluderet',
    noBinding: 'Ingen binding',
    readAboutEl: 'Læs om elaftaler',
    freeSolarTitle: 'Gratis solcelleaftale',
    freeProduction: 'Gratis produktionsaftale',
    noSubscription: 'Intet abonnement',
    autoSettlement: 'Automatisk afregning',
    onlyFreeDenmark: 'Eneste gratis i Danmark',
    seeSolar: 'Se solcelleaftale',
    completeSolution: 'Se komplet ladeløsning med el',
    readyToStart: 'Klar til at komme i gang?',
    chooseAndStart: 'Vælg din ladeboks og kom i gang med billig opladning',
    orderToday: 'Bestil {charger} i dag og kom i gang med billig opladning',
    selectThisCharger: 'Vælg denne ladeboks',
    seeAllChargers: 'Se alle ladebokse',
    noElPlanSelected: 'Ingen elaftale valgt',
    paymentNotice: 'Du betaler kun for ladeboks og evt. installation. Elaftale tilføjes separat efter bestilling.',
  },
  marketingPagesHardcoded: {
    reliable: 'Pålidelig',
    futureProof: 'Fremtidssikret',
    bestPriceDenmark: 'Skarp pris',
    elAftaleNoFee: 'Elaftale uden leverandørgebyr',
  },
  opladereHardcoded: {
    exclusiveEnkel: 'fra enkel energi',
  },
  // Charger pages
  chargerPages: {
    zaptecGoShortDesc: 'Populær og pålidelig ladeboks',
    zaptecGoDesc: 'Populær ladeboks med Wi-Fi og 4G',
    zaptecGoLongDesc1: 'Zaptec Go er en af Danmarks mest populære ladebokse. Den kombinerer pålidelighed med smart teknologi.',
    zaptecGoLongDesc2: 'Med Wi-Fi og 4G forbindelse kan du styre opladningen via enkel appen og spare op til 30% med Saving Mode.',
    smartChargeCompatible: 'Saving Mode kompatibel',
    saveUpTo30Percent: 'Spar op til 30% på opladning med intelligent styring',
    technicalSpecs: 'Tekniske specifikationer',
    powerAndSpeed: 'Effekt og hastighed',
    upTo22kw: 'Op til 22 kW ladeeffekt',
    threePhase: '3-faset tilslutning',
    max32a: 'Maks. 32A per fase',
    connection: 'Tilslutning',
    type2Standard: 'Type 2 stik (EU standard)',
    cableNotIncluded: 'Ladekabel medfølger ikke',
    smartFeatures: 'Smarte funktioner',
    wifi4g: 'Wi-Fi og 4G forbindelse',
    loadBalancing: 'Dynamisk lastbalancering',
    rfidReader: 'RFID læser til adgangskontrol',
    securityAndWarranty: 'Sikkerhed og garanti',
    warranty5year: '5 års garanti',
    midCertified: 'MID-certificeret elmåler',
    ip54Certified: 'IP54 vejrbestandighed',
    whatDuGetZaptecGo: 'Hvad får du med Zaptec Go?',
    smartConnection: 'Smart forbindelse',
    smartConnectionDesc: 'Wi-Fi og 4G sikrer altid forbindelse til enkel appen, så du kan styre opladningen hjemmefra eller på farten.',
    enkelSmartCharge: 'enkel Saving Mode',
    enkelSmartChargeDesc: 'Optimer automatisk din opladning til de billigste timer og spar op til 30% på strømregningen.',
    dynamicPowerMgmt: 'Dynamisk effektstyring',
    dynamicPowerMgmtDesc: 'Intelligent lastbalancering sikrer optimal udnyttelse af din installation uden at overbelaste.',
    warranty5yearTitle: '5 års garanti',
    warranty5yearDesc: 'Lang garanti giver tryghed og sikkerhed for din investering.',
    readyToStart: 'Klar til at komme i gang?',
    dynamicLoadBalancing: 'Dynamisk lastbalancering',
    rfidAccess: 'RFID adgangskontrol',
  },
  // Order section
  order: {
    orderYourCharger: 'Bestil din ladeboks',
    seeAllChargers: 'Se alle ladebokse',
    chargerAndInstallation: 'Ladeboks og installation',
    chargerPrice: 'Ladeboksens pris',
    chooseInstallation: 'Vælg installation',
    noInstallation: 'Ingen installation',
    existingInstallation: 'Eksisterende installation',
    standardInstallation: 'Standard installation',
    noInstallationDesc: 'Du installerer selv eller har allerede en autoriseret elektriker.',
    noInstallation1: 'Ladeboks sendes til din adresse',
    noInstallation2: 'Du finder selv elektriker til installation',
    noInstallation3: 'Hurtigste levering',
    existingInstallationDesc: 'Du har allerede en installation klar til ladeboks.',
    existingInstallation1: 'Ladeboks sendes til din adresse',
    existingInstallation2: 'Vores elektriker tilslutter ladeboksen',
    existingInstallation3: 'Eksisterende gruppe i tavle bruges',
    existingInstallation4: 'Tilslutning inden for 10 meter fra tavle',
    standardInstallationDesc: 'Komplet installation fra bund.',
    standardInstallation1: 'Ladeboks sendes til din adresse',
    standardInstallation2: 'Vores elektriker installerer komplet',
    standardInstallation3: 'Ny gruppe i tavle',
    standardInstallation4: 'Kabel fra tavle til ladeboks',
    standardInstallation5: 'Op til 10 meter kabel inkluderet',
    price: 'Pris',
    electricityPlan: 'Elaftale',
    charger: 'Ladeboks',
    orderSummary: 'Ordreoversigt',
    consumptionBilling: 'Forbrugsafregning',
    solarAgreement: 'Solcelleaftale',
    freeSolarProduction: 'Gratis produktionsaftale',
    month: 'md.',
    freeServiceAgreement: 'Gratis serviceaftale',
    totalOneTime: 'Total (engangsbetaling)',
  },
  opladere: {
    priceFrom: 'Fra',
    spotPriceExcludes: 'Spotpris ekskl. abn, net, afgifter og moms',
    selectCharger: 'Vælg ladeboks',
    keySpecs: 'Nøglespecifikationer',
    maxPower: 'Maks. effekt',
    years: 'år',
    warranty: 'Garanti',
    features: 'Funktioner',
    smartChargeIncluded: 'Saving Mode inkluderet',
    smartChargeDesc: 'Alle ladebokse er kompatible med enkel Saving Mode, som automatisk optimerer din opladning til de billigste timer.',
    feature22kw: 'Op til 22 kW ladeeffekt',
    featureWifi4g: 'Wi-Fi og 4G forbindelse',
    featureWifiBluetooth: 'Wi-Fi og Bluetooth',
    featureLoadBalancing: 'Dynamisk lastbalancering',
    featureRfid: 'RFID adgangskontrol',
    feature5YearWarranty: '5 års garanti',
    featureV2x: 'V2X ready',
    featureV2g: 'V2G ready',
    featureIp54: 'IP54 vejrbestandighed',
    featureSolar: 'Solcelle-optimeret',
    badgeReliable: 'Pålidelig',
    badgePremium: 'Premium',
    heroTitle1: 'Vælg din',
    heroTitle2: 'ladeboks',
    heroSubtitle: 'Alle ladebokse er kompatible med enkel Saving Mode',
    chooseCharger: 'Vælg din ladeboks',
    compatibleNote: 'Alle ladebokse er kompatible med enkel Saving Mode',
    alreadyHaveCharger: 'Har du allerede en',
    compatibleChargers: 'kompatibel ladeboks',
    chooseElHere: 'Vælg din elaftale her',
    compatibleChargersTitle: 'Kompatible ladebokse',
    smartChargeSupport: 'enkel Saving Mode understøtter følgende ladebokse:',
    smartChargeWorksVia: 'Saving Mode fungerer via ladeboksens cloud-forbindelse, så du får automatisk opladning til de billigste timer.',
    chooseElAftaleHere: 'Vælg elaftale her',
    processTitle: 'Sådan kommer du i gang',
    processSubtitle: 'Fra bestilling til opladning på 3 nemme trin',
    step1Title: 'Vælg ladeboks',
    step1Text: 'Vælg den ladeboks der passer til dine behov og tilføj eventuel installation.',
    step2Title: 'Vi leverer og installerer',
    step2Text: 'Vi sender ladeboksen og arrangerer installation, hvis du har valgt det.',
    step3Title: 'Begynd at spare',
    step3Text: 'Tilslut din bil og lad Saving Mode optimere din opladning automatisk.',
    faqTitle: 'Ofte stillede spørgsmål',
    faq1Q: 'Hvad er forskellen på ladeboksene?',
    faq1A: 'Zaptec Go er den mest populære med Wi-Fi og 4G. NexBlue Edge 2 er den billigste og har V2X support. Zaptec Go 2 er den nyeste med V2G teknologi.',
    faq2Q: 'Er installation inkluderet?',
    faq2A: 'Nej, installation er valgfrit. Du kan vælge mellem ingen installation, eksisterende installation eller fuld installation når du bestiller.',
    faq3Q: 'Kan jeg bruge min egen elektriker?',
    faq3A: 'Ja, du kan vælge at bestille ladeboksen uden installation og bruge din egen autoriserede elektriker.',
    faq4Q: 'Virker Saving Mode med alle ladebokse?',
    faq4A: 'Saving Mode virker med Zaptec Go, Zaptec Go 2, NexBlue Edge 2 og flere andre populære ladebokse via deres cloud-forbindelse.',
    finalCtaTitle: 'Klar til at komme i gang?',
    finalCtaSubtitle: 'Vælg din ladeboks og elaftale og begynd at spare på opladningen',
    seeChargers: 'Se ladebokse',
    onlyElAftale: 'Kun elaftale',
    latestRecognition: 'Seneste anerkendelser',
  },
  
  // Charger pages (chargerPages namespace)
  chargerPages: {
    // Common specs
    upTo22kw: 'Op til 22 kW ladeeffekt',
    wifi4g: 'Wi-Fi + 4G',
    wifiBluetooth: 'Wi-Fi + Bluetooth',
    dynamicLoadBalancing: 'Dynamisk load balancing',
    rfidAccess: 'RFID adgangskontrol',
    warranty5year: '5 års producentgaranti',
    midCertified: 'MID-certificeret elmåler',
    midCertifiedPrecise: 'MID-certificeret præcisionsmåling',
    ocppSupport: 'OCPP 1.6J support',
    threePhase: '3-faset opladning',
    max32a: 'Maksimalt 32A',
    type2Standard: 'Type 2 standard',
    cableNotIncluded: 'Ladekabel medfølger ikke',
    compactDesign: 'Kompakt skandinavisk design',
    testedDanish: 'Testet i dansk klima',
    ip54Certified: 'IP54 certificeret',
    ip54: 'IP54 vejrbestandig',
    groundFaultProtection: 'Indbygget fejlstrømsafbryder',
    groundFault: 'Indbygget fejlstrømsafbryder',
    faultCurrentBreaker: 'Integreret fejlstrømsafbryder Type B',
    v2gReady: 'V2G ready (hardware)',
    v2xReady: 'V2X ready (bidirektionel)',
    v2xReadyShort: 'V2X ready',
    solarPhaseSwitch: 'Automatisk faseomkobling (solceller)',
    solarOptimization: 'Solcelleoptimering',
    solarExcessOptimized: 'Optimeret til solcelleoverskud',
    type2NoCable: 'Type 2 uden fast kabel',
    weatherproofDesign: 'Vejrbestandigt design',
    compactRobust: 'Kompakt og robust',
    cloudLoadBalancing: 'Cloud-baseret load balancing',
    appControl: 'App-styring',
    ledStatus: 'LED statusindikator',
    builtInScreen: 'Indbygget skærm',
    
    // Section headers
    technicalSpecs: 'Tekniske specifikationer',
    powerAndSpeed: 'Effekt og hastighed',
    connection: 'Tilslutning',
    smartFeatures: 'Smarte funktioner',
    securityAndWarranty: 'Sikkerhed og garanti',
    
    // Feature descriptions
    smartConnection: 'Smart tilslutning',
    smartConnectionDesc: 'Zaptec Go har både Wi-Fi og 4G, så din ladeboks altid er online – uanset din internetforbindelse.',
    enkelSmartCharge: 'enkel Saving Mode',
    enkelSmartChargeApp: 'enkel Saving Mode app',
    enkelSmartChargeDesc: 'Med Saving Mode optimeres din opladning automatisk til de billigste timer – så du sparer op til 30%.',
    dynamicPowerMgmt: 'Dynamisk effektstyring',
    dynamicPowerMgmtDesc: 'Load balancing fordeler effekten intelligent mellem bilen og husets øvrige forbrug.',
    type2Plug: 'Type 2 tilslutning',
    type2PlugDesc: 'Standard Type 2 stik passer til alle moderne elbiler i Europa.',
    warranty5yearTitle: '5 års garanti',
    warranty5yearDesc: 'Zaptec leverer 5 års producentgaranti på alle ladebokse.',
    loadBalancing: 'Load balancing',
    rfidReader: 'RFID-læser',
    
    // Zaptec Go specific
    zaptecGoShortDesc: 'Populær og pålidelig ladeboks',
    zaptecGoDesc: 'Zaptec Go er en af de mest populære ladebokse i Skandinavien. Robust kvalitet, smart design og nem opsætning.',
    zaptecGoLongDesc1: 'Med op til 22 kW ladeeffekt og indbygget load balancing er Zaptec Go et sikkert valg til din elbil.',
    zaptecGoLongDesc2: 'Zaptec Go er fuldt kompatibel med enkel Saving Mode, så du automatisk oplader når strømmen er billigst.',
    whatDuGetZaptecGo: 'Det får du med Zaptec Go',
    orderZaptecGo: 'Bestil din Zaptec Go i dag og få billig strøm til din elbil.',
    
    // Zaptec Go 2 specific  
    zaptecGo2ShortDesc: 'Næste generation af ladebokse',
    zaptecGo2Desc: 'Zaptec Go 2 er den nyeste model med forbedrede forbindelsesmuligheder og teknologi forberedt til V2G.',
    zaptecGo2LongDesc1: 'Fremtidssikret med V2G hardware der gør din bil til et batteri i elnettet, og automatisk solcelleoptimering.',
    zaptecGo2LongDesc2: 'Fuldt kompatibel med enkel Saving Mode, så du automatisk oplader når strømmen er billigst.',
    whatDuGetZaptecGo2: 'Det får du med Zaptec Go 2',
    orderZaptecGo2: 'Bestil din Zaptec Go 2 i dag og vær klar til fremtidens elnet.',
    alwaysOnline: 'Altid online',
    alwaysOnlineDesc: 'Med både Wi-Fi og 4G er din ladeboks altid forbundet – også hvis dit internet går ned.',
    smartChargeCompatible: 'Saving Mode kompatibel',
    smartChargeCompatibleDesc: 'Automatisk optimering af din opladning til de billigste timer med enkel Saving Mode.',
    intelligentPowerMgmt: 'Intelligent effektstyring',
    intelligentPowerMgmtDesc: 'Avanceret load balancing og automatisk faseomkobling til solcelleoptimering.',
    type2Connection: 'Type 2 tilslutning',
    type2ConnectionDesc: 'Standard Type 2 stik – kompatibel med alle moderne elbiler.',
    nordicQuality: 'Nordisk kvalitet',
    nordicQualityDesc: 'Zaptec er designet og udviklet i Norge, med fokus på det skandinaviske klima.',
    
    // NexBlue specific
    whatDuGetNexblue: 'Det får du med NexBlue Edge 2',
    orderNexblue: 'Bestil din NexBlue Edge 2 i dag – Danmarks skarpeste pris.',
    wifiBluetoothTitle: 'Wi-Fi & Bluetooth',
    wifiBluetoothDesc: 'Forbind via Wi-Fi eller Bluetooth for nem opsætning og daglig brug.',
    smartChargeReady: 'Saving Mode klar',
    smartChargeReadyDesc: 'Fuldt kompatibel med enkel Saving Mode – oplad automatisk når strømmen er billigst.',
    loadBalancingTitle: 'Cloud load balancing',
    loadBalancingDesc: 'Intelligent fordeling af effekt via skyen – perfekt til husstande med solceller.',
    type2ConnectionDescNexblue: 'Standard Type 2 tilslutning – passer til alle moderne elbiler.',
    goodPriceQuality: 'Skarp pris/kvalitet',
    goodPriceQualityDesc: 'NexBlue Edge 2 giver dig premium funktioner til en skarp pris fra enkel energi.',
    
    // Saving Mode
    saveUpTo30Percent: 'Spar op til 30% på din opladning med automatisk prisoptimering.',
    
    // CTA
    readyToStart: 'Klar til at komme i gang?',
    selectThisCharger: 'Vælg denne ladeboks',
    seeAllChargers: 'Se alle ladebokse',
  },
  
  // NexBlue hardcoded
  // Widget translations (for ComparisonWidget)
  widget: {
    yearlyConsumption: 'Årligt forbrug (kWh)',
    selectProvider: 'Vælg elselskab',
    selectProviderPlaceholder: 'Vælg et elselskab',
    selectProduct: 'Vælg produkt',
    selectProductPlaceholder: 'Vælg et produkt',
    calculateSavings: 'Beregn besparelse',
    instructions: 'Vælg forbrug og elselskab for at se din besparelse',
    youCanSave: 'Du kan spare',
    perYear: 'kr./år',
    saveCta: 'Spar',
    signUpHere: 'tilmeld dig her',
    details: 'Detaljer',
    noSavingsMessage: 'Du vil måske ikke spare ved at skifte til enkel energi, men der er meget mere end bare prisen:',
    benefit1: 'Spotpris uden tillæg',
    benefit2: 'Saving Mode app inkluderet',
    benefit3: 'Ingen binding',
    benefit4: 'Serviceaftale inkluderet',
    contactForMore: 'Kontakt os for mere information',
    dataFrom: 'Data fra:',
    spotSurcharge: 'Tillæg til spot',
    yearlyCost: 'Årlig pris',
    monthlyCost: 'Månedlig pris',
  },

  // whatCostsEl translations (Hvad koster el gennem enkel page)
  whatCostsEl: {
    heroTitle: 'Hvad koster el gennem enkel?',
    heroSubtitle: 'Hos enkel energi betaler du kun for det, strømmen faktisk koster – plus et lille abonnement.',
    intro1: 'Vi mener, at elprisen skal være <strong>gennemsigtig og fair</strong>. Derfor får du hos os strøm til spotpris uden tillæg.',
    intro2: 'Dit eneste tillæg er et <strong>fast månedligt abonnement</strong> – et af de laveste på markedet.',
    whatDuPayFor: 'Det betaler du for hos enkel',
    spotNoMarkupTitle: 'Spotpris uden tillæg',
    spotNoMarkupText: 'Du betaler præcis det, strømmen koster på børsen – ikke en øre mere. Ingen skjulte tillæg.',
    monthlySubTitle: 'Månedligt abonnement',
    monthlySubText: 'Et fast, lavt abonnement fra kun 18 kr./md. for enkel kvartal, 28 kr./md. for enkel strøm, eller 48 kr./md. for enkel natur.',
    mandatoryFeesTitle: 'Lovpligtige afgifter og tariffer',
    mandatoryFeesText: 'Elafgift, nettariffer og moms – disse er ens hos alle elselskaber og går til staten og netselskaberne.',
    ourThreePlans: 'Vores tre elaftaler',
    additionalCostsQ: 'Er der skjulte omkostninger?',
    noSurcharges: '<strong>Nej</strong>. Hos enkel energi er der ingen skjulte gebyrer eller overraskelser.',
    noBinding: 'Ingen binding – opsig når som helst',
    freeSmartChargeApp: 'Gratis Saving Mode app til elbilsejere',
    noSetupFee: 'Intet oprettelsesgebyr',
    compareDinPrice: 'Sammenlign din pris',
    readyForTransparent: 'Klar til gennemsigtige elpriser?',
    switchToday: 'Skift til enkel energi i dag og få strøm til spotpris uden tillæg.',
    seeOurElPlans: 'Se vores elaftaler',
    relatedQuestions: 'Relaterede spørgsmål',
    canAllGetPower: 'Kan alle få strøm fra enkel?',
    readWhoCanBeCustomer: 'Læs om hvem der kan blive kunde',
    whatIsSmartCharge: 'Hvad er Saving Mode?',
    learnHowToSave: 'Lær hvordan du kan spare op til 30%',
  },

  // Comparison notices
  comparisonNotices: {
    altid: 'Bemærk: Altids abonnementspris stiger baseret på dit faktiske forbrug. Hvis du overskrider dit estimerede forbrug, betaler du et højere månedligt gebyr end vist her.',
    enly: 'Bemærk: ENLY tilbyder fastprisaftaler, som kan have overforbrugsgebyrer hvis dit forbrug overstiger den aftalte mængde.',
  },

  nexblueHardcoded: {
    description: 'Næste generation ladeboks – skarp pris fra enkel energi',
    exclusiveBadge: 'Skarpt tilbud fra enkel energi',
    heroText1: 'NexBlue Edge 2 er den smarteste vej til billig opladning.',
    heroText2: 'Med V2X ready hardware, cloud-baseret load balancing og Wi-Fi/Bluetooth er du klar til fremtidens elnet.',
    heroText3: 'NexBlue Edge 2 er fuldt kompatibel med enkel Saving Mode, så du automatisk oplader når strømmen er billigst.',
  },

  // Smart Sensor (NexBlue Zen)
  smartSensor: {
    addOn: 'Tilføj NexBlue Zen Strømsensor',
    dynamicLoadBalancing: 'Dynamisk lastbalancering',
    solarSurplus: 'Solcelle-overskudsopladning',
    energyMonitoring: 'Energiovervågning i realtid',
    description: 'NexBlue Zen er en intelligent strømsensor, der overvåger dit energiforbrug og optimerer opladningen af din elbil.',
    loadBalancingTitle: 'Dynamisk lastbalancering',
    loadBalancingDesc: 'Undgå overbelastning af dit el-system ved automatisk at justere opladehastigheden.',
    solarTitle: 'Solcelle-overskudsopladning',
    solarDesc: 'Brug overskudsstrøm fra dine solceller til at oplade din elbil gratis.',
    monitoringTitle: 'Energiovervågning',
    monitoringDesc: 'Se realtidsdata for dit forbrug, solproduktion og opladning.',
    installationTitle: 'Installation af strømsensor',
    installationShort: 'Installation aftales med elektriker',
    installationDesc: 'Installationspris for NexBlue Zen strømsensor aftales direkte med elektriker, da det kan variere betydeligt afhængigt af opsætningen i dit hjem.',
    installationLongDesc: 'Installation af NexBlue Zen strømsensor skal udføres af en autoriseret elektriker. Prisen varierer afhængigt af dit hjems opsætning, afstand til eltavle, og om der skal trækkes nye kabler. Kontakt en lokal elektriker for et tilbud.',
    standaloneNote: 'Bemærk: Ved køb uden ladeboks skal du selv finde en autoriseret elektriker til installation af strømsensoren.',
    installationTime: 'Installationstid: 15-60 minutter afhængigt af opsætning',
  },
  
  // Marketing pages (marketing namespace)
  marketing: {
    chargers: 'Opladere',
    heroSubtitle: 'Kvalitets-ladeboks uden elaftale – vælg selv om du vil have el fra enkel.',
    heroNote: 'Alle ladebokse er kompatible med enkel Saving Mode',
    seeChargers: 'Se ladebokse',
    chooseCharger: 'Vælg din ladeboks',
    allCompatible: 'Alle ladebokse er kompatible med enkel Saving Mode',
    chargerOnly: 'Kun ladeboks',
    seeCharger: 'Se ladeboks',
    saveUp30: 'Spar op til 30%',
    withSmartEl: 'Med elaftale + Saving Mode',
    freeSolar: 'Gratis solcelleaftale',
    onlyInDenmark: 'Den eneste gratis i Danmark',
    enkelApp: 'enkel app',
    aiCharging: 'AI-styret opladning',
    flexibleBilling: 'Fleksibel betaling',
    acontoOrConsumption: 'Aconto eller forbrugsafregning',
    getMoreTitle: 'Få mere med enkel',
    getMoreSubtitle: 'Kombiner din ladeboks med vores billige elaftale og gratis solcelleaftale.',
    spotNoMarkup: 'Spotpris uden tillæg',
    save30Charging: 'Spar op til 30% på opladning',
    freeSmartCharge: 'Saving Mode inkluderet',
    noBinding: 'Ingen binding',
    readAboutEl: 'Læs om elaftaler',
    freeSolarTitle: 'Gratis solcelleaftale',
    freeProduction: 'Produktionsaftale uden gebyr',
    noSubscription: 'Intet abonnement',
    autoSettlement: 'Automatisk afregning',
    onlyFreeDenmark: 'Den eneste gratis i DK',
    seeSolar: 'Se solcelleaftale',
    completeSolution: 'Se komplet løsning med elaftale',
    readyToStart: 'Klar til at komme i gang?',
    chooseAndStart: 'Vælg din ladeboks og kom i gang med billig opladning.',
    orderToday: 'Bestil din {charger} i dag.',
    orderTodayFuture: 'Bestil din {charger} i dag og vær klar til fremtiden.',
    orderTodayBestPrice: 'Bestil din {charger} i dag – skarp pris fra enkel.',
    selectThisCharger: 'Vælg denne ladeboks',
    seeAllChargers: 'Se alle ladebokse',
    noElPlanSelected: 'Ingen elaftale valgt (kun ladeboks)',
    paymentNotice: 'Uden elaftale kan ladeboksen ikke købes på kredit. Betaling sker ved levering.',
    futureProofTitle: 'Fremtidssikret',
    v2gReadyTitle: 'V2G Ready',
    v2gReadyDesc: 'Hardware klar til Vehicle-to-Grid – sælg strøm tilbage til nettet når priserne er høje.',
    v2xReadyTitle: 'V2X Ready',
    v2xReadyDesc: 'Forberedt til bidirektionel opladning – udnyt din elbil som strømlager.',
    solarOptimizationTitle: 'Solcelleoptimering',
    solarOptimizationDesc: 'Automatisk faseomkobling udnytter dit solcelleoverskud optimalt.',
    bestPriceTitle: 'Skarp pris',
    bestPriceDesc: 'NexBlue Edge 2 giver dig premium kvalitet til en skarp pris fra enkel energi.',
    wifiBluetoothDesc: 'Forbind via Wi-Fi eller Bluetooth – nem opsætning uden behov for 4G.',
    nexblueDesc: 'NexBlue Edge 2 er en prisvenlig kvalitetsladeboks med V2X ready hardware.',
    nexblueLongDesc1: 'Med V2X ready hardware og cloud-baseret load balancing er NexBlue Edge 2 fremtidssikret.',
    nexblueLongDesc2: 'Fuldt kompatibel med enkel Saving Mode – oplad automatisk når strømmen er billigst.',
  },
  
  // Marketing pages hardcoded
  marketingPagesHardcoded: {
    reliable: 'Pålidelig',
    futureProof: 'Fremtidssikret',
    bestPriceDenmark: 'Skarp pris fra enkel',
    exclusivePriceEnkel: 'skarpt tilbud fra enkel energi',
    nextGenCharger: 'Næste generation af ladebokse',
    elAftaleNoFee: 'Elaftale uden leverandørgebyr',
  },
  
  // Marketing solar page
  marketingSolar: {
    breadcrumb: 'Solcelleaftale',
    metaTitle: 'Gratis solcelleaftale | enkel energi',
    metaDesc: 'Få produktionsaftale til dine solceller uden leverandørgebyr.',
    badge: 'Gratis solcelleaftale',
    heroTitle: 'Solcelleaftale uden leverandørgebyr',
    heroSubtitle: 'Få afregning for din solcelleproduktion uden månedlige gebyrer.',
    orderNow: 'Bestil nu',
    warningTitle: 'Vidste du at de fleste betaler for deres solcelleaftale?',
    warningText: 'De fleste elselskaber tager et månedligt gebyr for din produktionsaftale. Hos enkel er det helt gratis.',
    missingBenefit1: 'Andre tager typisk 20-50 kr./md. for produktionsaftale',
    missingBenefit2: 'Mange har skjulte gebyrer i afregningen',
    missingBenefit3: 'Fra 2026 stiger gebyrerne yderligere',
    whatYouGet: 'Det får du med solcelleaftale',
    solarOnlyTitle: 'Kun solcelleaftale',
    zeroSupplierFee: '0 kr. i leverandørgebyr',
    benefit1: 'Produktionsaftale uden månedligt gebyr',
    benefit2: 'Automatisk afregning af dit overskud',
    benefit3: 'Ingen binding – opsig når du vil',
    noteText: 'Solcelleaftalen kan kombineres med elaftale for ekstra besparelser.',
    readyToOrder: 'Klar til at bestille?',
    orderSubtitle: 'Få din gratis solcelleaftale på under 2 minutter.',
    perMonth: 'pr. måned',
    canAddLater: 'Du kan altid tilføje elaftale senere',
    recommendationTitle: 'Anbefaling: Kombiner med elaftale',
    recommendationText: 'Få mest ud af dine solceller ved at kombinere med vores billige elaftale.',
    withElTitle: 'Med elaftale',
    withElBenefit1: 'Spotpris uden tillæg',
    withElBenefit2: 'Saving Mode inkluderet',
    withElBenefit3: 'Gratis solcelleaftale',
    withElBenefit4: 'Samlet overblik i app',
    solarOnlyBenefit1: 'Produktionsaftale uden gebyr',
    solarOnlyBenefit2: 'Ingen Saving Mode',
    solarOnlyBenefit3: 'Intet samlet overblik',
    solarOnlyBenefit4: 'Potentielt dyrere el andetsteds',
    seeElPlans: 'Se elaftaler',
    finalCtaTitle: 'Få din gratis solcelleaftale i dag',
    finalCtaSubtitle: 'Den eneste gratis solcelleaftale i Danmark.',
    orderSolarOnly: 'Bestil solcelleaftale',
  },
  
  // Opladere hardcoded
  opladereHardcoded: {
    exclusiveEnkel: 'fra enkel energi',
    result: 'Resultat:',
    danmarksBilligste: 'Skarp pris',
    januar2026: 'Januar 2026',
    testOf14: 'Test af 14 udbydere',
    cheapestSolution: 'billigste ladeløsning',
    latestRecognition: 'Seneste anerkendelser',
  },
  
  blogHardcoded: {
    chooseYourPlan: 'Vælg din løsning',
    allPlansNoBinding: 'Alle aftaler uden binding',
  },
  
  // FAQ Questions
  faqQuestions: {
    general1Q: 'Hvad koster det at få el gennem enkel energi?',
    general1A: 'Hos enkel energi får du 100% børsbaserede priser uden tillæg til spotprisen. Du betaler kun for det, strømmen reelt koster, plus lovpligtige afgifter og tariffer. Alle vores elaftaler inkluderer et lille abonnement – et af markedets laveste – som starter fra kun 18 kr./md.',
    general1Link: '/hvad-koster-el-gennem-enkel',
    general1LinkText: 'Læs meget mere om vores priser →',
    general2Q: 'Er enkel energi klar til 15-minutters afregning?',
    general2A: 'Ja, enkel energi er fuldt klar til 15-minutters afregning. Dette betyder endnu bedre muligheder for at spare penge ved at optimere dit elforbrug og ladning i de rigtige tidsrum. Med vores Saving Mode-teknologi kan du automatisk udnytte de billigste perioder.',
    general2Link: '/er-enkel-klar-til-15-minutters-afregning',
    general2LinkText: 'Læs meget mere om 15-minutters afregning →',
    general3Q: 'Kan alle få strøm fra enkel energi?',
    general3A: 'Ja, alle danske husstande kan få strøm fra enkel energi. Vi leverer el i hele Danmark og håndterer selv skiftet fra dit nuværende elselskab. Det tager kun 2 minutter at tilmelde dig, og vi sørger for alt det praktiske.',
    general3Link: '/kan-alle-faa-stroem-fra-enkel',
    general3LinkText: 'Læs meget mere om hvem der kan blive kunde →',
    general4Q: 'Hvor lang tid tager det at skifte til enkel energi?',
    general4A: 'Vi klarer skiftet fra dit nuværende elselskab. Vi kan overtage din elaftale med én dags varsel, altså dagen efter din tilmelding. Dit nuværende selskab kan dog have en opsigelsesfrist eller binding, du skal tage højde for.',
    general4Link: '/hvor-lang-tid-tager-det-at-skifte',
    general4LinkText: 'Læs meget mere om skifteprocessen →',
    general5Q: 'Skal jeg opsige hos mit nuværende elselskab?',
    general5A: 'Nej, det behøver du ikke. Når du tilmelder dig enkel energi, håndterer vi opsigelsen hos dit nuværende elselskab. Du skal bare huske at tjekke din nuværende aftales opsigelsesperiode, så du ved, hvornår skiftet kan ske.',
    general5Link: '/skal-jeg-opsige-hos-mit-nuvaerende-elselskab',
    general5LinkText: 'Læs meget mere om opsigelse →',
    general6Q: 'Hvordan tilmelder jeg mig enkel energi?',
    general6A: 'Vælg den elaftale, der passer til dig, og udfyld tilmeldingen. Det tager kun 2 minutter. Vi klarer resten, også skiftet fra dit nuværende elselskab.',
    general7Q: 'Hvad er forskellen på jeres elaftaler?',
    general7A: 'Vi tilbyder tre typer elaftaler: enkel kvartal (18 kr./md), enkel strøm (28 kr./md) og enkel natur (48 kr./md). Alle giver dig strøm til børsbaserede priser uden tillæg. Forskellen ligger i betalingsfrekvens og om du støtter danske naturprojekter. Hvis du vælger forbrugsafregning, tilkommer der 2 øre/kWh.',
    general8Q: 'Hvordan forstår jeg min elregning?',
    general8A: 'Din elregning består af flere dele: spotpris, abonnement, elafgift, tariffer og moms. Se vores detaljerede guide hvor du kan klikke på hver del for at forstå præcis hvad du betaler for.',
    general8Link: '/forstaa-din-elregning',
    general8LinkText: 'Læs vores guide til din elregning →',
    general9Q: 'Hvad sker der med elafgiften når jeg skifter midt i måneden?',
    general9A: 'Når du skifter elselskab midt i en kalendermåned, får du refunderet elafgiften fra dit gamle selskab for den periode, hvor du ikke længere er kunde. Samtidig opkræves elafgift hos enkel fra det tidspunkt, du bliver vores kunde. Dette sikrer, at du ikke betaler dobbelt elafgift under skiftet.',
    charger1Q: 'Virker enkel energi med alle ladebokse?',
    charger1A: 'Ja, vores Saving Mode-løsning fungerer med de fleste populære ladebokse på markedet, herunder Zaptec og NexBlue. Kontakt os, hvis du er i tvivl om din specifikke model er kompatibel.',
    charger1Link: '/virker-enkel-med-alle-ladebokse',
    charger1LinkText: 'Læs mere om kompatible ladebokse →',
    charger2Q: 'Hvad koster det at få installeret en ladeboks?',
    charger2A: 'Installation koster fra 1.300 kr. til 3.000 kr., afhængigt af om du har eksisterende installation eller skal have trukket nyt kabel. Dette er kun installation – prisen på selve ladeboksen kommer ovenpå.',
    charger2Link: '/hvad-koster-installation-af-ladeboks',
    charger2LinkText: 'Læs mere om installationspriser →',
    charger3Q: 'Kan jeg købe ladeboks uden elaftale?',
    charger3A: 'Ja, du kan sagtens købe en ladeboks hos enkel energi uden at tegne en elaftale. Vi tilbyder Zaptec Go, Zaptec Go 2 og NexBlue Edge 2 – med eller uden installation.',
    charger3Link: '/kan-jeg-koebe-ladeboks-uden-el-aftale',
    charger3LinkText: 'Læs mere om køb af ladeboks uden elaftale →',
    charger4Q: 'Hvilken ladeboks skal jeg vælge?',
    charger4A: 'Det afhænger af dine behov og budget. Zaptec Go er meget populær med smarte funktioner og robust design. Zaptec Go 2 er den nyeste model med næste generations teknologi. NexBlue Edge 2 er et prisvenligt alternativ.',
    charger4Link: '/hvilken-ladeboks-skal-jeg-vaelge',
    charger4LinkText: 'Sammenlign ladebokse →',
    smartCharge1Q: 'Hvad er enkel Saving Mode?',
    smartCharge1A: 'enkel Saving Mode er vores intelligente opladningssystem, der automatisk planlægger opladning til de billigste timer. Du sætter din afgangstid og ønskede batteriniveau – så finder systemet automatisk de perioder, hvor strømmen er billigst. Det er inkluderet for alle vores kunder.',
    smartCharge2Q: 'Hvad er enkel-appen?',
    smartCharge2A: 'Med enkel-appen kan du styre opladningen derhjemme og planlægge den efter elprisen og din afgangstid. Du kan også se dit forbrug i kWh og dine tidligere opladninger. Hent appen til iOS eller Android.',
    smartCharge3Q: 'Hvor meget kan jeg spare med Saving Mode?',
    smartCharge3A: 'Med Saving Mode lader du automatisk i de billigste perioder hver dag – ikke kun kl. 01-04. Besparelsen afhænger af din brug og prisudviklingen.',
    pioneersQ: 'Hvad er Enkel Pioneers?',
    pioneersA: 'Enkel Pioneers er et program, hvor udvalgte kunder har været med til at teste og forme vores smarte opladning og energiløsninger. Programmet har givet os uvurderlig indsigt i, hvordan løsningerne fungerer i praksis.',
    pioneersLink: '/pioneers',
    pioneersLinkText: 'Læs mere om Pioneers',
    solar1Q: 'Tilbyder enkel energi solcelleaftaler?',
    solar1A: 'Ja! Vi tilbyder en solcelleaftale uden leverandørgebyr, når du vælger enkel som din produktionsleverandør. Din overskudsproduktion afregnes via elbørsen. Du betaler kun lovpligtige omkostninger og transportgebyrer – ingen leverandørgebyrer.',
    solar2Q: 'Kan jeg kombinere solceller med en elbil?',
    solar2A: 'Ja, men der findes ingen automatisk integration mellem solcelleproduktion og opladning endnu.',
  },
  
  // Price Chart
  priceChart: {
    currentPrice: 'Nuværende pris',
    lowestPrice: 'Laveste pris',
    highestPrice: 'Højeste pris',
    average: 'Gennemsnit',
    postalCode: 'Postnummer',
    postalCodePlaceholder: 'Indtast postnummer',
    supplier: 'Netselskab',
    noSuppliers: 'Ingen netselskaber',
    timePeriod: 'Tidsperiode',
    '15min': '15 min',
    '1hour': '1 time',
    loading: 'Indlæser data...',
    error: 'Fejl',
    noData: 'Ingen data',
    total: 'Total',
    basis: 'Basis',
    transportation: 'Transport',
    vat: 'Moms',
    elTax: 'Elafgift',
    reducedElTax: 'Reduceret elafgift',
  },
  
  // Support Portal
  supportPortal: {
    heroTitle: 'Support & Kundeportal',
    heroSubtitle: 'Alt samlet ét sted – find svar, tilgå din konto, eller kontakt os.',
    customerQuestion: 'Er du kunde hos enkel energi?',
    selectBestFit: 'Vælg det der passer dig bedst',
    yesCustomer: 'Ja, jeg er kunde',
    noNotCustomer: 'Nej, ikke endnu',
    portalAccessHint: 'Dit kundenummer finder du på din velkomstmail eller elregning.',
    customerNumberLabel: 'Kundenummer',
    customerNumberPlaceholder: 'K1234567',
    customerNumberFormat: 'Format: K + 7 cifre (f.eks. K1234567)',
    nextButton: 'Næste',
    customerNumberConfirmed: 'Kundenummer bekræftet:',
    notCustomerMessage: 'Du kan stadig se vores FAQ og kontakte os. Når du bliver kunde, får du adgang til kundeportalen.',
    portalTitle: 'Kundeportal',
    portalDescription: 'Her kan du se dit forbrug, dine fakturaer og administrere din aftale.',
    saveButton: 'Gem',
    understandBill: 'Forstå din regning',
    openPortalFullscreen: 'Åbn kundeportal i fuldskærm',
    faqSelfService: 'FAQ & Selvbetjening',
    contactUs: 'Kontakt os',
    didNotFindAnswer: 'Fandt du ikke svar på dit spørgsmål?',
    openContactForm: 'Åbn kontaktformular',
    tipsGuidesArticles: 'Tips, guides & artikler',
    seeAllArticles: 'Se alle artikler',
  },
  
  // Customer Portal
  customerPortal: {
    title: 'Kundeportal',
    danishOnlyNotice: 'Kundeportalen er kun tilgængelig på dansk',
    leavePortal: 'Forlad kundeportal',
    leaveWarningTitle: 'Forlad kundeportal?',
    leaveWarningMessage: 'Du er ved at forlade kundeportalen. Ikke-gemte ændringer kan gå tabt. Hvis du vil logge ud, skal du gøre det inde i kundeportalen først.',
  },
  
  // Service Agreement Page
  serviceAgreement: {
    heroBadge: 'Gratis for alle el-kunder',
    heroTitle: 'Velkommen til din serviceaftale',
    heroSubtitle: 'Få mest muligt ud af din ladeboks og spar endnu mere med Saving Mode. Her finder du guides til at komme i gang.',
    guidesTitle: 'Kom i gang med din ladeløsning',
    guidesSubtitle: 'Vælg din ladeboks eller app for at følge vores trin-for-trin guide til opsætning.',
    importantTitle: 'Vigtigt: Hold din ladeboks forbundet',
    importantText: 'Din serviceaftale kræver, at din ladeboks er online og forbundet til enkel app. Uden forbindelse kan vi ikke garantere Saving Mode, elafgiftsrefusion og support.',
    readTerms: 'Læs de fulde betingelser',
    smartChargeBadge: 'Gratis for alle el-kunder',
    smartChargeTitle: 'Spar op til 30% med Saving Mode',
    smartChargeDesc: 'Saving Mode optimerer automatisk din opladning til de billigste timer på døgnet. Du sætter bare afgangstid og ønsket batteriniveau – så klarer vi resten.',
    smartChargeBullet1: 'Automatisk opladning når strømmen er billigst',
    smartChargeBullet2: 'Sæt afgangstid og lad appen klare resten',
    smartChargeBullet3: 'Fuld kontrol via enkel-appen',
    smartChargeLink: 'Læs mere om Saving Mode',
    smartChargeSavings: 'sammenlignet med straks-opladning',
    smartChargeSavingsDesc: 'Ved at lade når strømmen er billigst, sparer du typisk 20-30% på din opladning sammenlignet med at lade straks, når du sætter bilen til.',
    includedTitle: 'Det er inkluderet – gratis for alle el-kunder',
    benefitSmartCharge: 'Saving Mode',
    benefitSmartChargeDesc: 'Automatisk optimering af opladning til de billigste timer',
    benefitApp: 'enkel app',
    benefitAppDesc: 'Fuld kontrol over din opladning fra din telefon',
    benefitRefund: 'Elafgiftsrefusion',
    benefitRefundDesc: 'Vi håndterer refusion af elafgift for dig',
    benefitSupport: 'Teknisk support',
    benefitSupportDesc: 'Hjælp til fejlfinding og opsætning',
    ctaTitle: 'Brug for hjælp?',
    ctaSubtitle: 'Vores supportteam er klar til at hjælpe dig med opsætning og eventuelle spørgsmål.',
    ctaContact: 'Kontakt support',
    ctaCall: 'Ring 70 60 80 07',
  },
  
  // Order section
  order: {
    orderDurCharger: 'Bestil din ladeboks',
    orderYourCharger: 'Bestil din ladeboks',
    seeAllChargers: 'Se alle ladebokse',
    chargerAndInstallation: 'Ladeboks + installation',
    chargerPrice: 'Ladeboksens pris',
    chooseInstallation: 'Vælg installation',
    noInstallation: 'Uden installation',
    existingInstallation: 'Eksisterende installation',
    standardInstallation: 'Standard installation',
    noInstallationDesc: 'Du modtager kun ladeboksen og installerer selv eller bruger egen elektriker.',
    noInstallation1: 'Ladeboks sendes med fragtfirma',
    noInstallation2: 'Du står selv for installation',
    noInstallation3: 'Kontakt din egen elektriker',
    existingInstallationDesc: 'Vi udskifter din nuværende ladeboks med den nye og genbruger kabelføringen. Har du i stedet kraftstik, kan ladeboksen monteres dér.',
    existingInstallation1: 'Eksisterende ladeboksinstallation eller kraftstik',
    existingInstallation2: 'Ladeboks monteres på eksisterende',
    existingInstallation3: 'Hurtig og enkel opsætning',
    existingInstallation4: 'Inkluderer test og godkendelse',
    standardInstallationDesc: 'Komplet installation med ny installation fra eltavle til ladeboks.',
    standardInstallation1: 'Op til 10 meter kabel fra eltavle',
    standardInstallation2: 'Ny gruppe i eltavle',
    standardInstallation3: 'Professionel montering',
    standardInstallation4: 'Test og godkendelse',
    standardInstallation5: 'Alt udføres af autoriseret el-installatør',
    standardInstallationNote: 'Ved længere kabeltræk eller komplicerede forhold kan der forekomme tillæg.',
    price: 'Pris',
    orderSummary: 'Ordreoversigt',
    charger: 'Ladeboks',
    electricityPlan: 'Elaftale',
    consumptionBilling: 'Forbrugsafregning',
    solarAgreement: 'Solcelleaftale',
    freeSolarProduction: 'Gratis produktionsaftale',
    month: 'md.',
    freeServiceAgreement: 'Gratis serviceaftale inkluderet',
    totalOneTime: 'Total (engangsbetaling)',
    chargedOnFirstBill: 'Ladeboks opkræves på første el-regning.',
    selectElPlanAlert: 'Vælg venligst en elaftale',
    selectElPlanNote: 'Vælg elaftale for at fortsætte',
    notSelected: 'Ikke valgt',
    electricityAtSpot: 'El til spotpris uden tillæg',
    included: 'Inkluderet',
    chooseElPlan: 'Vælg elaftale',
  },
};